import {
    RECEIVE_CHARACTER_DATA,
    SET_CHARACTER_ERROR,
    REQUEST_CHARACTER_DATA,
    REQUEST_HEADINGS_ABOUT,
    RECEIVE_HEADINGS_ABOUT,
    SET_CHARACTER_HEADINGS_ABOUT_ERROR,
    SET_CHARACTER_HEADINGS_ROOTS_ERROR,
    RECEIVE_HEADINGS_ROOTS,
    REQUEST_HEADINGS_ROOTS,
    RECEIVE_HEADINGS_CHILDREN,
    REQUEST_HEADINGS_CHILDREN,
    SET_CHARACTER_HEADING_CHILDREN_ERROR,
    RECEIVE_FIELD_CHILDREN,
    SET_HEADINGS_SEARCH_KEY,
    RECEIVE_HEADINGS_TITLE_RESULTS,
    REQUEST_HEADINGS_TITLE_RESULTS,
    SET_CHARACTER_HEADING_TITLE_RESULTS_ERROR,
    RESET_HEADINGS_SEARCH_KEY
    } from '../constants/ActionTypes';

const initialState = {
    isFetching: false,
    isLoadingError: false,
    isFetchingHeadingsAbout: false,
    isLoadingErrorHeadingsAbout: false,
    isFetchingHeadingsRoots: false,
    isLoadingErrorHeadingsRoots: false,
    isFetchingHeadingChildren: {},
    isLoadingErrorHeadingChildren: {},
    isFetchingHeadingTitleResults: false,
    isLoadingErrorTitleResults: false,
    titleResults: [],
    titleHeadingsSearchParams: {
        key: ''
    },
};

export default function characteristics(state = initialState, action) {
    switch (action.type) {
        case SET_CHARACTER_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case SET_CHARACTER_HEADINGS_ABOUT_ERROR:
            return {
                ...state,
                isFetchingHeadingsAbout: false,
                isLoadingErrorHeadingsAbout: true
            };
        case SET_CHARACTER_HEADINGS_ROOTS_ERROR:
            return {
                ...state,
                isFetchingHeadingsRoots: false,
                isLoadingErrorHeadingsRoots: true
            };
        case SET_CHARACTER_HEADING_TITLE_RESULTS_ERROR:
            return {
                ...state,
                isFetchingHeadingTitleResults: false,
                isLoadingErrorTitleResults: true,
            };
        case SET_CHARACTER_HEADING_CHILDREN_ERROR:
            return {
                ...state,
                isFetchingHeadingChildren: { ...state.isFetchingHeadingChildren, [`${action.name}`]: false},
                isLoadingErrorHeadingChildren: { ...state.isLoadingErrorHeadingChildren, [`${action.name}`]: true},
            };
        case REQUEST_CHARACTER_DATA:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case REQUEST_HEADINGS_ABOUT:
            return {
                ...state,
                isFetchingHeadignsAbout: true,
                isLoadingErrorHeadingsAbout: false
            };
        case REQUEST_HEADINGS_ROOTS:
            return {
                ...state,
                isFetchingHeadingsRoots: true,
                isLoadingErrorHeadingsRoots: false
            };
        case REQUEST_HEADINGS_TITLE_RESULTS:
            return {
                ...state,
                isFetchingHeadingTitleResults: true,
                isLoadingErrorTitleResults: false
            };
        case REQUEST_HEADINGS_CHILDREN:
            return {
                ...state,
                isFetchingHeadingChildren: { ...state.isFetchingHeadingChildren, [`${action.name}`]: true},
                isLoadingErrorHeadingChildren: { ...state.isLoadingErrorHeadingChildren, [`${action.name}`]: false},
            };
        case RECEIVE_CHARACTER_DATA:
            return {
                ...state,
                isFetching: false,
                aboutData: {
                    ...action.data
                }
            };
        case RECEIVE_HEADINGS_ABOUT:
            return {
                ...state,
                isFetchingHeadignsAbout: false,
                aboutHeadingsData: {
                    ...action.data
                }
            };
        case RECEIVE_HEADINGS_ROOTS:
            return {
                ...state,
                isFetchingHeadingsRoots: false,
                rootsHeadingsData: action.data
            };
        case RECEIVE_HEADINGS_TITLE_RESULTS:
            return {
                ...state,
                isFetchingHeadingTitleResults: false,
                titleResults: action.data
            };
        case RECEIVE_HEADINGS_CHILDREN:
            return {
                ...state,
                isFetchingHeadingChildren: { ...state.isFetchingHeadingChildren, [`${action.name}`]: false},
                rootsHeadingsData: state.rootsHeadingsData ?
                                      state.rootsHeadingsData.map(arrItem => arrItem.domainCode === action.name ?
                                      {
                                          ...arrItem,
                                          children: action.data
                                      }
                                      : arrItem)
                                   : []
            };
        case RECEIVE_FIELD_CHILDREN:
            const setChildren = arr => {
                return arr.map(arrItem => arrItem.id === action.data.id ?
                          {
                              ...arrItem,
                              children: action.data.children
                          }
                          : arrItem.children ?
                              {
                                  ...arrItem,
                                  children: setChildren(arrItem.children)
                              } : arrItem)
            };

            return {
                ...state,
                rootsHeadingsData: state.rootsHeadingsData ? setChildren(state.rootsHeadingsData) : []
            };
        case SET_HEADINGS_SEARCH_KEY:
            return {
                ...state,
                titleHeadingsSearchParams: {...state.titleHeadingsSearchParams, key: action.key}
            }
        case RESET_HEADINGS_SEARCH_KEY:
            return {
                ...state,
                titleHeadingsSearchParams: {...state.titleHeadingsSearchParams, key: ''}
            }
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/characteristics.js